import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7464d098"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "stock-monitor"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "main-title flex align-center"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "监控画面", -1);
});
var _hoisted_5 = {
  class: "box mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_line_echart = _resolveComponent("line-echart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.title) + " ", 1), _createElementVNode("span", {
    class: "back ml-auto",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.back && _ctx.back.apply(_ctx, arguments);
    })
  }, "返回")]), _hoisted_4, (_openBlock(), _createElementBlock("div", {
    id: "video-container",
    key: _ctx.randomKey
  })), _createElementVNode("div", _hoisted_5, [_createVNode(_component_line_echart, _normalizeProps(_guardReactiveProps(_ctx.stockTrend)), null, 16)])])]);
}